export default class ClientDebounce {
  timeOutId: number | NodeJS.Timeout

  debounce = (f: () => void, time: number) => {
    clearTimeout(this.timeOutId)

    this.timeOutId = setTimeout(f, time)
  }

  clear = () => {
    clearTimeout(this.timeOutId)
  }
}
